// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero {
  display: flex;
  min-height: 500px;
  background: linear-gradient(135deg, #0C111B 0%, #131b2c 100%);
  color: white;
  padding: 2rem;
  position: relative;
  overflow: hidden;
}

.hero::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  right: -50%;
  bottom: -50%;
  background: radial-gradient(circle at center, rgba(153, 69, 255, 0.05) 0%, rgba(0, 0, 0, 0) 70%);
  z-index: 0;
  animation: pulse-bg 15s ease-in-out infinite alternate;
}

@keyframes pulse-bg {
  0%, 100% { opacity: 0.3; }
  50% { opacity: 0.6; }
}

.hero-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 2rem;
  position: relative;
  z-index: 1;
}

.hero-content h1 {
  font-size: 3.5rem;
  margin-bottom: 1rem;
  color: white;
  text-shadow: 0 0 30px rgba(153, 69, 255, 0.5);
  background: linear-gradient(to right, #ffffff, #9945FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-content p {
  font-size: 1.2rem;
  margin-bottom: 2rem;
  max-width: 600px;
  line-height: 1.6;
  color: #9BA5B7;
}

.hero-buttons {
  display: flex;
  gap: 1rem;
}

.btn {
  padding: 0.8rem 1.5rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.7s ease;
}

.btn:hover::before {
  left: 100%;
}

.btn.primary {
  background: linear-gradient(90deg, #9945FF, #14F195);
  color: #0C111B;
  box-shadow: 0 5px 15px rgba(153, 69, 255, 0.3);
}

.btn.primary:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(153, 69, 255, 0.4);
}

.btn.secondary {
  background: transparent;
  color: #9945FF;
  border: 2px solid #9945FF;
  box-shadow: 0 0 15px rgba(153, 69, 255, 0.1);
}

.btn.secondary:hover {
  background-color: rgba(153, 69, 255, 0.1);
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(153, 69, 255, 0.2);
}

.hero-image {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Dream Lifestyle Illustration Styles */
.dream-lifestyle-illustration {
  width: 380px;
  height: 380px;
  position: relative;
  background-color: transparent;
  border-radius: 15px;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4);
  overflow: hidden;
  transition: all 0.5s ease;
  animation: float 6s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-15px) rotate(1deg);
  }
}

.room-wall {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 75%;
  background: linear-gradient(to bottom, #3a3a5a 0%, #2a2a45 100%);
  z-index: 1;
}

.room-floor {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 25%;
  background: linear-gradient(to bottom, #2d2d48 0%, #1a1a30 100%);
  transform: perspective(500px) rotateX(30deg);
  transform-origin: bottom;
  z-index: 1;
}

.illustration-label {
  position: absolute;
  bottom: 10px;
  right: 10px;
  color: #14F195;
  font-size: 0.9rem;
  font-weight: bold;
  text-shadow: 0 0 10px rgba(20, 241, 149, 0.5);
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 5px 10px;
  border-radius: 20px;
}

.window-frame {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 75%;
  background-color: transparent;
  border-radius: 0 0 4px 4px;
  border: 5px solid #3a3a50;
  border-top: none;
  border-right: none;
  border-left: none;
  overflow: hidden;
  box-shadow: inset 0 0 15px rgba(0, 0, 0, 0.2), 0 10px 20px rgba(0, 0, 0, 0.3);
  z-index: 5;
}

.window-frame:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  background: linear-gradient(
    135deg,
    rgba(42, 42, 64, 0.1) 0%,
    rgba(42, 42, 64, 0.2) 50%,
    rgba(42, 42, 64, 0.3) 100%
  );
  z-index: 8;
}

.window-depth {
  position: absolute;
  bottom: -5px;
  left: 0;
  width: 100%;
  height: 5px;
  background-color: #2a2a40;
  z-index: 6;
}

.window-sill {
  display: none;
}

.window-frame-vertical {
  position: absolute;
  top: 0;
  left: 33%;
  width: 4px;
  height: 100%;
  background-color: #3a3a50;
  z-index: 7;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.window-frame-vertical:after {
  content: '';
  position: absolute;
  top: 0;
  left: 100px;
  width: 4px;
  height: 100%;
  background-color: #3a3a50;
  z-index: 7;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.window-frame-horizontal {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: #3a3a50;
  z-index: 7;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}

.window-view {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: 6;
}

.sky {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 60%;
  background: linear-gradient(to bottom, #FF7B54 0%, #FFB26B 40%, #FFD56F 60%, #939B62 100%);
}

.sun {
  position: absolute;
  top: 30px;
  right: 80px;
  width: 60px;
  height: 60px;
  background: radial-gradient(circle, #ffee93 0%, #ffb347 60%, #ff8d47 100%);
  border-radius: 50%;
  box-shadow: 0 0 30px rgba(255, 179, 71, 0.8);
  animation: sunset-glow 10s ease-in-out infinite;
  opacity: 0.9;
}

@keyframes sunset-glow {
  0%, 100% {
    opacity: 0.9;
    transform: scale(1);
    box-shadow: 0 0 30px rgba(255, 179, 71, 0.8);
  }
  50% {
    opacity: 1;
    transform: scale(1.05);
    box-shadow: 0 0 40px rgba(255, 179, 71, 1);
  }
}

.city-skyline {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40%;
  background: linear-gradient(to bottom, #939B62 0%, #4B5267 100%);
  z-index: 2;
}

/* City silhouette in the foreground */
.city-silhouette {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 15%;
  background-color: #1a1a30;
  z-index: 3;
  clip-path: polygon(
    0% 100%, 
    0% 30%, 
    5% 60%, 
    10% 40%, 
    15% 70%, 
    20% 30%, 
    25% 80%, 
    30% 20%, 
    35% 50%, 
    40% 30%, 
    45% 60%, 
    50% 30%, 
    55% 70%, 
    60% 40%, 
    65% 80%, 
    70% 30%, 
    75% 50%, 
    80% 20%, 
    85% 40%, 
    90% 60%, 
    95% 30%,
    100% 70%, 
    100% 100%
  );
}

.buildings {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
}

.building {
  position: absolute;
  bottom: 0;
  background-color: #2a2a40;
  box-shadow: inset 0 0 10px rgba(255, 179, 71, 0.2);
  z-index: 3;
}

.building-1 {
  left: 20px;
  width: 40px;
  height: 60%;
}

.building-2 {
  left: 70px;
  width: 35px;
  height: 80%;
}

.building-3 {
  left: 120px;
  width: 50px;
  height: 70%;
}

.building-4 {
  left: 180px;
  width: 45px;
  height: 90%;
}

.building-5 {
  left: 235px;
  width: 40px;
  height: 65%;
}

.building-6 {
  left: 290px;
  width: 35px;
  height: 75%;
}

.windows {
  position: absolute;
  top: 10%;
  left: 10%;
  width: 80%;
  height: 80%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(5, 1fr);
  gap: 3px;
}

.building-window {
  background-color: rgba(255, 207, 51, 0.5);
  border-radius: 1px;
  animation: window-flicker 4s ease-in-out infinite;
}

@keyframes window-flicker {
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 0.8;
  }
  75% {
    opacity: 0.6;
  }
}

.clouds {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 6;
}

.cloud {
  position: absolute;
  background-color: rgba(255, 221, 170, 0.7);
  border-radius: 50%;
}

.cloud-1 {
  top: 45px;
  left: 20px;
  width: 60px;
  height: 20px;
  animation: cloud-move 25s linear infinite;
}

.cloud-1:before, .cloud-1:after {
  content: '';
  position: absolute;
  background-color: rgba(255, 221, 170, 0.7);
  border-radius: 50%;
}

.cloud-1:before {
  width: 30px;
  height: 30px;
  top: -15px;
  left: 5px;
}

.cloud-1:after {
  width: 25px;
  height: 25px;
  top: -10px;
  left: 30px;
}

.cloud-2 {
  top: 25px;
  left: -60px;
  width: 50px;
  height: 15px;
  animation: cloud-move 30s linear infinite 8s;
}

.cloud-2:before, .cloud-2:after {
  content: '';
  position: absolute;
  background-color: rgba(255, 221, 170, 0.7);
  border-radius: 50%;
}

.cloud-2:before {
  width: 25px;
  height: 25px;
  top: -10px;
  left: 5px;
}

.cloud-2:after {
  width: 20px;
  height: 20px;
  top: -8px;
  left: 25px;
}

@keyframes cloud-move {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(300px);
  }
}

/* Remove islands since we're replacing with city */
.islands, .island, .island-1, .island-2, .ocean {
  display: none;
}

.desk {
  position: absolute;
  bottom: 70px;
  left: 50px;
  width: 280px;
  height: 20px;
  background: linear-gradient(to bottom, #a37a53 0%, #8a6246 50%, #6d4c3d 100%);
  border-radius: 4px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5), 0 0 0 2px rgba(163, 122, 83, 0.2);
  z-index: 10;
}

.desk:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 5px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 4px 4px 0 0;
}

.desk:before {
  content: '';
  position: absolute;
  top: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #be8e63;
  border-radius: 4px 4px 0 0;
}

.desk-legs {
  position: absolute;
  bottom: -55px;
  left: 20px;
  width: 15px;
  height: 55px;
  background-color: #5a3d2f;
  border-radius: 2px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.desk-legs:after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 225px;
  width: 15px;
  height: 55px;
  background-color: #5a3d2f;
  border-radius: 2px;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.desk-items {
  position: absolute;
  top: -30px;
  right: 40px;
  z-index: 11;
}

.coffee-cup {
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 25px;
  background-color: #fff;
  border-radius: 3px 3px 10px 10px;
  transform: rotate(-5deg);
}

.coffee-cup:before {
  content: '';
  position: absolute;
  top: 5px;
  left: -8px;
  width: 10px;
  height: 12px;
  border: 3px solid #fff;
  border-radius: 10px 0 0 10px;
  border-right: none;
}

.coffee-cup:after {
  content: '';
  position: absolute;
  top: 3px;
  left: 3px;
  width: 14px;
  height: 5px;
  background-color: #6f4e37;
  border-radius: 2px;
}

.coffee-steam {
  position: absolute;
  top: -10px;
  left: 5px;
  width: 2px;
  height: 10px;
  background-color: rgba(255, 255, 255, 0.6);
  border-radius: 10px;
  animation: steam 2s ease-out infinite;
}

.coffee-steam:before, .coffee-steam:after {
  content: '';
  position: absolute;
  width: 2px;
  height: 8px;
  background-color: rgba(255, 255, 255, 0.6);
  border-radius: 10px;
}

.coffee-steam:before {
  top: -2px;
  left: 5px;
  transform: rotate(30deg);
  animation: steam 2s ease-out infinite 0.6s;
}

.coffee-steam:after {
  top: -1px;
  left: -5px;
  transform: rotate(-30deg);
  animation: steam 2s ease-out infinite 1.2s;
}

@keyframes steam {
  0% {
    opacity: 0.3;
    transform: translateY(0) scaleX(1);
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0;
    transform: translateY(-10px) scaleX(1.5);
  }
}

.notebook {
  position: absolute;
  top: 2px;
  right: 35px;
  width: 35px;
  height: 25px;
  background-color: #f2f2f2;
  border-radius: 2px;
  transform: rotate(5deg);
  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);
}

.notebook:after {
  content: '';
  position: absolute;
  top: 5px;
  left: 5px;
  width: 25px;
  height: 2px;
  background-color: #ccc;
  box-shadow: 0 4px 0 #ccc, 0 8px 0 #ccc, 0 12px 0 #ccc;
}

.laptop {
  position: absolute;
  bottom: 89px;
  left: 110px;
  z-index: 12;
}

.laptop-screen {
  width: 100px;
  height: 70px;
  background-color: #252525;
  border-radius: 5px 5px 0 0;
  transform: perspective(300px) rotateX(10deg);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  animation: screen-glow 4s ease-in-out infinite;
  position: relative;
}

.laptop-screen:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, #1A1E26 0%, #252A34 100%);
  border-radius: 3px;
  z-index: 1;
}

/* Code snippet styles */
.code-snippet {
  position: absolute;
  top: 5px;
  left: 5px;
  right: 5px;
  bottom: 5px;
  z-index: 2;
  display: flex;
  font-family: 'Consolas', 'Monaco', monospace;
  font-size: 4px;
  line-height: 1.5;
  overflow: hidden;
}

.code-line-numbers {
  display: flex;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0.3);
  padding: 1px 2px;
  margin-right: 3px;
  color: #777;
  font-size: 4px;
  text-align: right;
}

.code-line-numbers span {
  display: block;
  padding: 0 1px;
  line-height: 1.5;
  font-size: 4px;
}

.code-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.code-text {
  white-space: nowrap;
  margin-bottom: 0;
  color: #E0E0E0;
  font-size: 4px;
  line-height: 1.5;
}

.code-text.indent {
  padding-left: 10px;
}

.code-text.doubled {
  padding-left: 20px;
}

.keyword {
  color: #FF79C6;
  font-weight: bold;
}

.function {
  color: #50FA7B;
}

.namespace {
  color: #BD93F9;
}

.symbol {
  color: #F8F8F2;
}

.property {
  color: #8BE9FD;
  font-style: italic;
}

.cursor-blink {
  position: absolute;
  width: 4px;
  height: 8px;
  background-color: #F8F8F2;
  opacity: 0.7;
  bottom: 18px;
  right: 35px;
  animation: blink 1s step-end infinite;
  z-index: 3;
}

@keyframes blink {
  0%, 100% {
    opacity: 0.7;
  }
  50% {
    opacity: 0;
  }
}

.laptop-keyboard {
  width: 120px;
  height: 10px;
  background-color: #333;
  border-radius: 0 0 5px 5px;
  transform: perspective(300px) rotateX(70deg);
  transform-origin: top;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.5);
}

.laptop-keyboard:after {
  content: '';
  position: absolute;
  top: 4px;
  left: 50%;
  width: 20px;
  height: 2px;
  background-color: #444;
  transform: translateX(-50%);
  border-radius: 2px;
}

.code-lines {
  position: absolute;
  top: 10px;
  left: 10px;
  right: 10px;
  z-index: 13;
}

.code-line {
  height: 3px;
  background-color: #14F195;
  margin-bottom: 8px;
  opacity: 0.8;
  width: 60%;
  border-radius: 3px;
}

.code-line:nth-child(2) {
  width: 45%;
}

.code-line:nth-child(3) {
  width: 75%;
}

.solana-logo-small {
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 15px;
  height: 15px;
  background-color: #14F195;
  border-radius: 50%;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% {
    opacity: 0.7;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
}

.person {
  position: absolute;
  bottom: 90px;
  left: 110px;
  z-index: 15;
  transform: rotate(0deg);
}

.head {
  width: 30px;
  height: 35px;
  background-color: #ffd9b3;
  border-radius: 50% 50% 45% 45%;
  position: relative;
  animation: head-move 4s ease-in-out infinite;
  transform: rotate(-5deg);
}

@keyframes head-move {
  0%, 100% {
    transform: rotate(-5deg);
  }
  30% {
    transform: rotate(-2deg);
  }
  70% {
    transform: rotate(-7deg);
  }
}

.hair {
  position: absolute;
  top: -10px;
  left: -2px;
  width: 34px;
  height: 25px;
  background-color: #4a3500;
  border-radius: 50% 50% 0 0;
}

.face {
  position: relative;
  width: 100%;
  height: 100%;
}

.eyes {
  position: absolute;
  top: 15px;
  left: 5px;
  width: 20px;
  height: 4px;
  display: flex;
  justify-content: space-between;
}

.eyes:before, .eyes:after {
  content: '';
  width: 4px;
  height: 4px;
  background-color: #333;
  border-radius: 50%;
  animation: blink 4s infinite;
}

@keyframes blink {
  0%, 96%, 100% {
    transform: scaleY(1);
  }
  98% {
    transform: scaleY(0.1);
  }
}

.smile {
  position: absolute;
  bottom: 8px;
  left: 10px;
  width: 10px;
  height: 5px;
  border-bottom: 2px solid #333;
  border-radius: 50%;
}

.body {
  position: absolute;
  top: 35px;
  left: 3px;
  width: 25px;
  height: 50px;
  background-color: #14B898;
  border-radius: 8px 8px 0 0;
  transform: rotate(0deg);
  animation: subtle-sway 5s ease-in-out infinite;
}

@keyframes subtle-sway {
  0%, 100% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(-1deg);
  }
}

.arms {
  position: absolute;
  top: 8px;
  left: -5px;
  width: 45px;
  height: 30px;
}

.arm {
  position: absolute;
  width: 30px;
  height: 5px;
  background-color: #14B898;
  border-radius: 5px;
}

.arm-left {
  top: 15px;
  left: -15px;
  transform: rotate(25deg);
}

.arm-right {
  top: 15px;
  right: -15px;
  transform: rotate(-30deg);
  animation: typing 2s infinite;
}

@keyframes typing {
  0%, 100% {
    transform: rotate(-30deg) translateY(0);
  }
  50% {
    transform: rotate(-35deg) translateY(-2px);
  }
}

.legs {
  position: absolute;
  top: 80px;
  left: -5px;
  width: 35px;
  height: 60px;
}

.leg {
  position: absolute;
  width: 8px;
  height: 40px;
  background-color: #14B898;
  border-radius: 4px;
}

.leg-left {
  left: 3px;
  transform: rotate(0deg);
  animation: weight-shift 4s ease-in-out infinite alternate;
}

.leg-right {
  right: 3px;
  transform: rotate(0deg);
  animation: weight-shift 4s ease-in-out infinite alternate-reverse;
}

@keyframes weight-shift {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-1px) rotate(0deg);
  }
}

.leg:after {
  content: '';
  position: absolute;
  bottom: -3px;
  left: -2px;
  width: 12px;
  height: 5px;
  background-color: #333;
  border-radius: 3px 5px 3px 3px;
  transform: rotate(0deg);
}

.potted-plant {
  position: absolute;
  bottom: 70px;
  right: 40px;
  z-index: 9;
}

.potted-plant:before {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 25px;
  height: 20px;
  background-color: #bd7b4c;
  border-radius: 3px 3px 5px 5px;
}

.potted-plant:after {
  content: '';
  position: absolute;
  bottom: 15px;
  left: 5px;
  width: 15px;
  height: 35px;
  background-color: #0fad7a;
  border-radius: 50% 50% 0 0;
  box-shadow: -10px -5px 0 -5px #0fad7a, 10px -10px 0 -5px #0fad7a;
}

.wall-art {
  position: absolute;
  top: 40px;
  right: 60px;
  width: 50px;
  height: 35px;
  background: linear-gradient(45deg, #14F195, #3a82ee);
  border-radius: 3px;
  border: 3px solid #5c6c8e;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);
  z-index: 5;
}

.wall-art:before {
  content: '';
  position: absolute;
  top: -10px;
  left: 50%;
  width: 2px;
  height: 10px;
  background-color: #ddd;
  transform: translateX(-50%);
}

.wall-art:after {
  content: '';
  position: absolute;
  top: -12px;
  left: 50%;
  width: 10px;
  height: 2px;
  background-color: #ddd;
  transform: translateX(-50%);
}

/* WeChat QR Code Popup Styles */
.wechat-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
}

.wechat-popup {
  background-color: white;
  border-radius: 10px;
  width: 90%;
  max-width: 400px;
  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  animation: popup-appear 0.3s ease;
}

@keyframes popup-appear {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.wechat-popup-header {
  background-color: #14F195;
  color: #1E1E2E;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.wechat-popup-header h3 {
  margin: 0;
  font-size: 1.2rem;
}

.close-btn {
  background: none;
  border: none;
  color: #1E1E2E;
  font-size: 1.5rem;
  cursor: pointer;
  line-height: 1;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}

.close-btn:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.wechat-popup-content {
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.wechat-popup-image {
  max-width: 200px;
  margin-bottom: 1rem;
  border: 2px solid #14F195;
  border-radius: 5px;
}

.wechat-popup-content p {
  color: #555;
  margin: 0;
}

@media (max-width: 768px) {
  .hero {
    flex-direction: column;
    padding: 1rem;
  }
  
  .hero-content {
    padding: 0;
    margin-bottom: 2rem;
    text-align: center;
  }
  
  .hero-buttons {
    justify-content: center;
  }
  
  .dream-lifestyle-illustration {
    width: 320px;
    height: 320px;
  }
  
  .window-frame {
    height: 65%;
  }

  .window-reflection {
    bottom: 70px;
    height: 40px;
  }

  .city-glow {
    top: 80px;
    left: 30px;
    width: 260px;
  }

  .illustration-label {
    font-size: 0.8rem;
  }

  .wechat-popup {
    width: 95%;
  }

  .wechat-popup-image {
    max-width: 150px;
  }
  
  /* Adjust building positions for mobile */
  .building-1 {
    left: 10px;
    width: 30px;
  }
  
  .building-2 {
    left: 45px;
    width: 25px;
  }
  
  .building-3 {
    left: 80px;
    width: 40px;
  }
  
  .building-4 {
    left: 125px;
    width: 35px;
  }
  
  .building-5 {
    left: 165px;
    width: 30px;
  }
  
  .building-6 {
    left: 200px;
    width: 25px;
  }
}

@keyframes screen-glow {
  0%, 100% {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  }
  50% {
    box-shadow: 0 0 15px rgba(20, 241, 149, 0.3);
  }
}

/* Window reflection on floor */
.window-reflection {
  position: absolute;
  bottom: 70px;
  left: 0;
  width: 100%;
  height: 60px;
  background: linear-gradient(to bottom, rgba(255, 123, 84, 0.2) 0%, rgba(75, 82, 103, 0.05) 100%);
  filter: blur(5px);
  transform: perspective(300px) rotateX(70deg) scale(1, 0.4);
  opacity: 0.3;
  z-index: 2;
  border-radius: 0;
}

/* City light glow effect */
.city-glow {
  position: absolute;
  top: 100px;
  left: 50px;
  width: 280px;
  height: 20px;
  background: radial-gradient(ellipse at center, rgba(255, 179, 71, 0.2) 0%, rgba(255, 179, 71, 0) 70%);
  filter: blur(10px);
  opacity: 0.6;
  z-index: 2;
}

/* Hide elements that conflict with the expanded window */
.wall-art {
  display: none;
}

.potted-plant {
  display: none;
}

/* Car lights on city streets */
.car-lights {
  position: absolute;
  bottom: 5%;
  left: 0;
  width: 100%;
  height: 3px;
  z-index: 4;
}

.car {
  position: absolute;
  height: 2px;
  border-radius: 2px;
}

.car-1 {
  width: 8px;
  background-color: rgba(255, 255, 255, 0.8);
  bottom: 0;
  left: -10px;
  animation: car-move-right 8s linear infinite;
}

.car-2 {
  width: 6px;
  background-color: rgba(255, 100, 100, 0.8);
  bottom: 8px;
  right: -8px;
  animation: car-move-left 12s linear infinite 3s;
}

.car-3 {
  width: 7px;
  background-color: rgba(255, 255, 255, 0.8);
  bottom: 16px;
  left: -12px;
  animation: car-move-right 10s linear infinite 2s;
}

@keyframes car-move-right {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(380px);
  }
}

@keyframes car-move-left {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-380px);
  }
}

/* Add more car lights for the wider window */
.car-4 {
  width: 9px;
  background-color: rgba(255, 255, 255, 0.8);
  bottom: 24px;
  left: -15px;
  animation: car-move-right 15s linear infinite 5s;
}

.car-5 {
  width: 7px;
  background-color: rgba(255, 100, 100, 0.8);
  bottom: 32px;
  right: -10px;
  animation: car-move-left 18s linear infinite 7s;
}

/* Airplane styles with improved visibility and contrail */
.airplane {
  position: absolute;
  z-index: 6;
}

.airplane-body {
  position: absolute;
  width: 40px;
  height: 8px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 50% 50% 0 0;
}

.airplane-tail {
  position: absolute;
  top: -8px;
  right: 0;
  width: 10px;
  height: 10px;
  background-color: rgba(255, 255, 255, 0.9);
  clip-path: polygon(0% 100%, 100% 100%, 100% 0%);
}

.airplane-wing {
  position: absolute;
  top: 4px;
  left: 10px;
  width: 30px;
  height: 6px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 50% 50% 0 0;
  transform: rotate(10deg);
}

.airplane-contrail {
  position: absolute;
  top: 4px;
  right: -50px;
  width: 50px;
  height: 2px;
  background: linear-gradient(to left, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.6));
}

.airplane-1 {
  top: 40px;
  left: -50px;
  animation: fly-right 30s linear infinite;
}

.airplane-2 {
  top: 80px;
  right: -50px;
  transform: scale(0.3) rotateY(180deg);
  animation: fly-left 45s linear infinite 15s;
}

/* Birds styles with improved visibility */
.birds {
  position: absolute;
  z-index: 6;
}

.bird {
  position: absolute;
  width: 10px;
  height: 8px;
  clip-path: polygon(0% 50%, 50% 0%, 100% 50%);
  background-color: rgba(0, 0, 0, 0.65);
  animation: bird-flap 0.8s ease-in-out infinite;
}

.bird-group-1 {
  top: 30px;
  left: -30px;
  transform: scale(0.8);
  animation: bird-fly-right 20s linear infinite 2s;
}

.bird-group-2 {
  top: 60px;
  right: -30px;
  transform: scale(0.6) rotate(180deg);
  animation: bird-fly-left 25s linear infinite 7s;
}

.bird-group-3 {
  top: 20px;
  left: 50%;
  transform: scale(0.5) translateX(-50%);
  animation: bird-fly-up 35s linear infinite 5s;
}

.bird-1 {
  top: 0;
  left: 0;
}

.bird-2 {
  top: -5px;
  left: 15px;
}

.bird-3 {
  top: 0;
  left: 30px;
}

.bird-4 {
  top: 5px;
  left: 10px;
}

.bird-5 {
  top: 5px;
  left: 25px;
}

@keyframes bird-flap {
  0%, 100% {
    clip-path: polygon(0% 50%, 50% 0%, 100% 50%);
  }
  50% {
    clip-path: polygon(0% 45%, 50% 10%, 100% 45%);
  }
}

@keyframes bird-fly-right {
  0% {
    transform: scale(0.8) translateX(0) translateY(0);
  }
  50% {
    transform: scale(0.8) translateX(160px) translateY(-20px);
  }
  100% {
    transform: scale(0.8) translateX(320px) translateY(0);
  }
}

@keyframes bird-fly-left {
  0% {
    transform: scale(0.6) rotate(180deg) translateX(0) translateY(0);
  }
  50% {
    transform: scale(0.6) rotate(180deg) translateX(140px) translateY(15px);
  }
  100% {
    transform: scale(0.6) rotate(180deg) translateX(280px) translateY(0);
  }
}

@keyframes bird-fly-up {
  0% {
    transform: scale(0.5) translateX(-50%) translateY(0);
    opacity: 0;
  }
  10% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  100% {
    transform: scale(0.5) translateX(-50%) translateY(-120px);
    opacity: 0;
  }
}

/* Animation keyframes for airplane */
@keyframes fly-right {
  0% {
    transform: scale(0.5) translateX(0) translateY(0);
  }
  50% {
    transform: scale(0.5) translateX(200px) translateY(-10px);
  }
  100% {
    transform: scale(0.5) translateX(400px) translateY(0);
  }
}

@keyframes fly-left {
  0% {
    transform: scale(0.3) rotateY(180deg) translateX(0) translateY(0);
  }
  50% {
    transform: scale(0.3) rotateY(180deg) translateX(150px) translateY(10px);
  }
  100% {
    transform: scale(0.3) rotateY(180deg) translateX(300px) translateY(0);
  }
}

/* Section transition element */
.hero-transition-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50px;
  background: linear-gradient(to bottom, transparent, #131b2c);
  z-index: 2;
}

.hero-dots {
  position: absolute;
  bottom: 15px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 24px;
  letter-spacing: 8px;
  color: rgba(153, 69, 255, 0.4);
  z-index: 3;
} 
`, "",{"version":3,"sources":["webpack://./src/components/HeroSection.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gGAAgG;EAChG,UAAU;EACV,sDAAsD;AACxD;;AAEA;EACE,WAAW,YAAY,EAAE;EACzB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,6CAA6C;EAC7C,uDAAuD;EACvD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oDAAoD;EACpD,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,wCAAwC;AACxC;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,gEAAgE;EAChE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,gEAAgE;EAChE,4CAA4C;EAC5C,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,6CAA6C;EAC7C,WAAW;EACX,oCAAoC;EACpC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,6EAA6E;EAC7E,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB;;;;;GAKC;EACD,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,0FAA0F;AAC5F;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,0EAA0E;EAC1E,kBAAkB;EAClB,4CAA4C;EAC5C,+CAA+C;EAC/C,YAAY;AACd;;AAEA;EACE;IACE,YAAY;IACZ,mBAAmB;IACnB,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,sBAAsB;IACtB,0CAA0C;EAC5C;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,gEAAgE;EAChE,UAAU;AACZ;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV;;;;;;;;;;;;;;;;;;;;;;;;GAwBC;AACH;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,kDAAkD;EAClD,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,QAAQ;AACV;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,mDAAmD;AACnD;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,6EAA6E;EAC7E,kBAAkB;EAClB,4EAA4E;EAC5E,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,YAAY;EACZ,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,wBAAwB;EACxB,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,UAAU;EACV,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE;IACE,YAAY;IACZ,kCAAkC;EACpC;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;IACV,wCAAwC;EAC1C;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,4CAA4C;EAC5C,uCAAuC;EACvC,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,6DAA6D;EAC7D,kBAAkB;EAClB,UAAU;AACZ;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,UAAU;EACV,aAAa;EACb,4CAA4C;EAC5C,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oCAAoC;EACpC,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,qCAAqC;EACrC,UAAU;AACZ;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,0BAA0B;EAC1B,4CAA4C;EAC5C,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,4CAA4C;EAC5C,wBAAwB;AAC1B;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE;IACE,uCAAuC;EACzC;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,yDAAyD;AAC3D;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,iEAAiE;AACnE;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,0BAA0B;EAC1B,gEAAgE;AAClE;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oDAAoD;EACpD,kBAAkB;EAClB,yBAAyB;EACzB,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,SAAS;IACT,UAAU;IACV,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA,yCAAyC;EACzC;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,WAAW;IACX,WAAW;EACb;;EAEA;IACE,WAAW;IACX,WAAW;EACb;AACF;;AAEA;EACE;IACE,uCAAuC;EACzC;EACA;IACE,4CAA4C;EAC9C;AACF;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,YAAY;EACZ,gGAAgG;EAChG,iBAAiB;EACjB,0DAA0D;EAC1D,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,qGAAqG;EACrG,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA,yDAAyD;AACzD;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,WAAW;EACX,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,0CAA0C;EAC1C,SAAS;EACT,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,UAAU;EACV,0CAA0C;EAC1C,WAAW;EACX,WAAW;EACX,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,0CAA0C;EAC1C,YAAY;EACZ,WAAW;EACX,gDAAgD;AAClD;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA,6CAA6C;AAC7C;EACE,UAAU;EACV,0CAA0C;EAC1C,YAAY;EACZ,WAAW;EACX,gDAAgD;AAClD;;AAEA;EACE,UAAU;EACV,0CAA0C;EAC1C,YAAY;EACZ,YAAY;EACZ,+CAA+C;AACjD;;AAEA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,WAAW;EACX,0CAA0C;EAC1C,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,WAAW;EACX,sFAAsF;AACxF;;AAEA;EACE,SAAS;EACT,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,4CAA4C;EAC5C,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,oCAAoC;EACpC,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,SAAS;EACT,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,MAAM;EACN,OAAO;AACT;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE;IACE,4CAA4C;EAC9C;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE;IACE,iDAAiD;EACnD;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,qDAAqD;EACvD;AACF;;AAEA;EACE;IACE,gEAAgE;EAClE;EACA;IACE,uEAAuE;EACzE;EACA;IACE,oEAAoE;EACtE;AACF;;AAEA;EACE;IACE,oDAAoD;IACpD,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,yDAAyD;IACzD,UAAU;EACZ;AACF;;AAEA,qCAAqC;AACrC;EACE;IACE,iDAAiD;EACnD;EACA;IACE,yDAAyD;EAC3D;EACA;IACE,qDAAqD;EACvD;AACF;;AAEA;EACE;IACE,iEAAiE;EACnE;EACA;IACE,wEAAwE;EAC1E;EACA;IACE,qEAAqE;EACvE;AACF;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,4DAA4D;EAC5D,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;AACZ","sourcesContent":[".hero {\n  display: flex;\n  min-height: 500px;\n  background: linear-gradient(135deg, #0C111B 0%, #131b2c 100%);\n  color: white;\n  padding: 2rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.hero::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  right: -50%;\n  bottom: -50%;\n  background: radial-gradient(circle at center, rgba(153, 69, 255, 0.05) 0%, rgba(0, 0, 0, 0) 70%);\n  z-index: 0;\n  animation: pulse-bg 15s ease-in-out infinite alternate;\n}\n\n@keyframes pulse-bg {\n  0%, 100% { opacity: 0.3; }\n  50% { opacity: 0.6; }\n}\n\n.hero-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 0 2rem;\n  position: relative;\n  z-index: 1;\n}\n\n.hero-content h1 {\n  font-size: 3.5rem;\n  margin-bottom: 1rem;\n  color: white;\n  text-shadow: 0 0 30px rgba(153, 69, 255, 0.5);\n  background: linear-gradient(to right, #ffffff, #9945FF);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.hero-content p {\n  font-size: 1.2rem;\n  margin-bottom: 2rem;\n  max-width: 600px;\n  line-height: 1.6;\n  color: #9BA5B7;\n}\n\n.hero-buttons {\n  display: flex;\n  gap: 1rem;\n}\n\n.btn {\n  padding: 0.8rem 1.5rem;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.7s ease;\n}\n\n.btn:hover::before {\n  left: 100%;\n}\n\n.btn.primary {\n  background: linear-gradient(90deg, #9945FF, #14F195);\n  color: #0C111B;\n  box-shadow: 0 5px 15px rgba(153, 69, 255, 0.3);\n}\n\n.btn.primary:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 8px 25px rgba(153, 69, 255, 0.4);\n}\n\n.btn.secondary {\n  background: transparent;\n  color: #9945FF;\n  border: 2px solid #9945FF;\n  box-shadow: 0 0 15px rgba(153, 69, 255, 0.1);\n}\n\n.btn.secondary:hover {\n  background-color: rgba(153, 69, 255, 0.1);\n  transform: translateY(-3px);\n  box-shadow: 0 5px 15px rgba(153, 69, 255, 0.2);\n}\n\n.hero-image {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Dream Lifestyle Illustration Styles */\n.dream-lifestyle-illustration {\n  width: 380px;\n  height: 380px;\n  position: relative;\n  background-color: transparent;\n  border-radius: 15px;\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.4);\n  overflow: hidden;\n  transition: all 0.5s ease;\n  animation: float 6s ease-in-out infinite;\n}\n\n@keyframes float {\n  0%, 100% {\n    transform: translateY(0) rotate(0deg);\n  }\n  50% {\n    transform: translateY(-15px) rotate(1deg);\n  }\n}\n\n.room-wall {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 75%;\n  background: linear-gradient(to bottom, #3a3a5a 0%, #2a2a45 100%);\n  z-index: 1;\n}\n\n.room-floor {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 25%;\n  background: linear-gradient(to bottom, #2d2d48 0%, #1a1a30 100%);\n  transform: perspective(500px) rotateX(30deg);\n  transform-origin: bottom;\n  z-index: 1;\n}\n\n.illustration-label {\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n  color: #14F195;\n  font-size: 0.9rem;\n  font-weight: bold;\n  text-shadow: 0 0 10px rgba(20, 241, 149, 0.5);\n  z-index: 20;\n  background-color: rgba(0, 0, 0, 0.5);\n  padding: 5px 10px;\n  border-radius: 20px;\n}\n\n.window-frame {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 75%;\n  background-color: transparent;\n  border-radius: 0 0 4px 4px;\n  border: 5px solid #3a3a50;\n  border-top: none;\n  border-right: none;\n  border-left: none;\n  overflow: hidden;\n  box-shadow: inset 0 0 15px rgba(0, 0, 0, 0.2), 0 10px 20px rgba(0, 0, 0, 0.3);\n  z-index: 5;\n}\n\n.window-frame:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  background: linear-gradient(\n    135deg,\n    rgba(42, 42, 64, 0.1) 0%,\n    rgba(42, 42, 64, 0.2) 50%,\n    rgba(42, 42, 64, 0.3) 100%\n  );\n  z-index: 8;\n}\n\n.window-depth {\n  position: absolute;\n  bottom: -5px;\n  left: 0;\n  width: 100%;\n  height: 5px;\n  background-color: #2a2a40;\n  z-index: 6;\n}\n\n.window-sill {\n  display: none;\n}\n\n.window-frame-vertical {\n  position: absolute;\n  top: 0;\n  left: 33%;\n  width: 4px;\n  height: 100%;\n  background-color: #3a3a50;\n  z-index: 7;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n}\n\n.window-frame-vertical:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 100px;\n  width: 4px;\n  height: 100%;\n  background-color: #3a3a50;\n  z-index: 7;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n}\n\n.window-frame-horizontal {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background-color: #3a3a50;\n  z-index: 7;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);\n}\n\n.window-view {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  z-index: 6;\n}\n\n.sky {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 60%;\n  background: linear-gradient(to bottom, #FF7B54 0%, #FFB26B 40%, #FFD56F 60%, #939B62 100%);\n}\n\n.sun {\n  position: absolute;\n  top: 30px;\n  right: 80px;\n  width: 60px;\n  height: 60px;\n  background: radial-gradient(circle, #ffee93 0%, #ffb347 60%, #ff8d47 100%);\n  border-radius: 50%;\n  box-shadow: 0 0 30px rgba(255, 179, 71, 0.8);\n  animation: sunset-glow 10s ease-in-out infinite;\n  opacity: 0.9;\n}\n\n@keyframes sunset-glow {\n  0%, 100% {\n    opacity: 0.9;\n    transform: scale(1);\n    box-shadow: 0 0 30px rgba(255, 179, 71, 0.8);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1.05);\n    box-shadow: 0 0 40px rgba(255, 179, 71, 1);\n  }\n}\n\n.city-skyline {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 40%;\n  background: linear-gradient(to bottom, #939B62 0%, #4B5267 100%);\n  z-index: 2;\n}\n\n/* City silhouette in the foreground */\n.city-silhouette {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 15%;\n  background-color: #1a1a30;\n  z-index: 3;\n  clip-path: polygon(\n    0% 100%, \n    0% 30%, \n    5% 60%, \n    10% 40%, \n    15% 70%, \n    20% 30%, \n    25% 80%, \n    30% 20%, \n    35% 50%, \n    40% 30%, \n    45% 60%, \n    50% 30%, \n    55% 70%, \n    60% 40%, \n    65% 80%, \n    70% 30%, \n    75% 50%, \n    80% 20%, \n    85% 40%, \n    90% 60%, \n    95% 30%,\n    100% 70%, \n    100% 100%\n  );\n}\n\n.buildings {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 3;\n}\n\n.building {\n  position: absolute;\n  bottom: 0;\n  background-color: #2a2a40;\n  box-shadow: inset 0 0 10px rgba(255, 179, 71, 0.2);\n  z-index: 3;\n}\n\n.building-1 {\n  left: 20px;\n  width: 40px;\n  height: 60%;\n}\n\n.building-2 {\n  left: 70px;\n  width: 35px;\n  height: 80%;\n}\n\n.building-3 {\n  left: 120px;\n  width: 50px;\n  height: 70%;\n}\n\n.building-4 {\n  left: 180px;\n  width: 45px;\n  height: 90%;\n}\n\n.building-5 {\n  left: 235px;\n  width: 40px;\n  height: 65%;\n}\n\n.building-6 {\n  left: 290px;\n  width: 35px;\n  height: 75%;\n}\n\n.windows {\n  position: absolute;\n  top: 10%;\n  left: 10%;\n  width: 80%;\n  height: 80%;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: repeat(5, 1fr);\n  gap: 3px;\n}\n\n.building-window {\n  background-color: rgba(255, 207, 51, 0.5);\n  border-radius: 1px;\n  animation: window-flicker 4s ease-in-out infinite;\n}\n\n@keyframes window-flicker {\n  0%, 100% {\n    opacity: 0.5;\n  }\n  50% {\n    opacity: 0.8;\n  }\n  75% {\n    opacity: 0.6;\n  }\n}\n\n.clouds {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 6;\n}\n\n.cloud {\n  position: absolute;\n  background-color: rgba(255, 221, 170, 0.7);\n  border-radius: 50%;\n}\n\n.cloud-1 {\n  top: 45px;\n  left: 20px;\n  width: 60px;\n  height: 20px;\n  animation: cloud-move 25s linear infinite;\n}\n\n.cloud-1:before, .cloud-1:after {\n  content: '';\n  position: absolute;\n  background-color: rgba(255, 221, 170, 0.7);\n  border-radius: 50%;\n}\n\n.cloud-1:before {\n  width: 30px;\n  height: 30px;\n  top: -15px;\n  left: 5px;\n}\n\n.cloud-1:after {\n  width: 25px;\n  height: 25px;\n  top: -10px;\n  left: 30px;\n}\n\n.cloud-2 {\n  top: 25px;\n  left: -60px;\n  width: 50px;\n  height: 15px;\n  animation: cloud-move 30s linear infinite 8s;\n}\n\n.cloud-2:before, .cloud-2:after {\n  content: '';\n  position: absolute;\n  background-color: rgba(255, 221, 170, 0.7);\n  border-radius: 50%;\n}\n\n.cloud-2:before {\n  width: 25px;\n  height: 25px;\n  top: -10px;\n  left: 5px;\n}\n\n.cloud-2:after {\n  width: 20px;\n  height: 20px;\n  top: -8px;\n  left: 25px;\n}\n\n@keyframes cloud-move {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(300px);\n  }\n}\n\n/* Remove islands since we're replacing with city */\n.islands, .island, .island-1, .island-2, .ocean {\n  display: none;\n}\n\n.desk {\n  position: absolute;\n  bottom: 70px;\n  left: 50px;\n  width: 280px;\n  height: 20px;\n  background: linear-gradient(to bottom, #a37a53 0%, #8a6246 50%, #6d4c3d 100%);\n  border-radius: 4px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5), 0 0 0 2px rgba(163, 122, 83, 0.2);\n  z-index: 10;\n}\n\n.desk:after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 5px;\n  background-color: rgba(255, 255, 255, 0.2);\n  border-radius: 4px 4px 0 0;\n}\n\n.desk:before {\n  content: '';\n  position: absolute;\n  top: -2px;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background-color: #be8e63;\n  border-radius: 4px 4px 0 0;\n}\n\n.desk-legs {\n  position: absolute;\n  bottom: -55px;\n  left: 20px;\n  width: 15px;\n  height: 55px;\n  background-color: #5a3d2f;\n  border-radius: 2px;\n  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.desk-legs:after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 225px;\n  width: 15px;\n  height: 55px;\n  background-color: #5a3d2f;\n  border-radius: 2px;\n  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);\n}\n\n.desk-items {\n  position: absolute;\n  top: -30px;\n  right: 40px;\n  z-index: 11;\n}\n\n.coffee-cup {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 20px;\n  height: 25px;\n  background-color: #fff;\n  border-radius: 3px 3px 10px 10px;\n  transform: rotate(-5deg);\n}\n\n.coffee-cup:before {\n  content: '';\n  position: absolute;\n  top: 5px;\n  left: -8px;\n  width: 10px;\n  height: 12px;\n  border: 3px solid #fff;\n  border-radius: 10px 0 0 10px;\n  border-right: none;\n}\n\n.coffee-cup:after {\n  content: '';\n  position: absolute;\n  top: 3px;\n  left: 3px;\n  width: 14px;\n  height: 5px;\n  background-color: #6f4e37;\n  border-radius: 2px;\n}\n\n.coffee-steam {\n  position: absolute;\n  top: -10px;\n  left: 5px;\n  width: 2px;\n  height: 10px;\n  background-color: rgba(255, 255, 255, 0.6);\n  border-radius: 10px;\n  animation: steam 2s ease-out infinite;\n}\n\n.coffee-steam:before, .coffee-steam:after {\n  content: '';\n  position: absolute;\n  width: 2px;\n  height: 8px;\n  background-color: rgba(255, 255, 255, 0.6);\n  border-radius: 10px;\n}\n\n.coffee-steam:before {\n  top: -2px;\n  left: 5px;\n  transform: rotate(30deg);\n  animation: steam 2s ease-out infinite 0.6s;\n}\n\n.coffee-steam:after {\n  top: -1px;\n  left: -5px;\n  transform: rotate(-30deg);\n  animation: steam 2s ease-out infinite 1.2s;\n}\n\n@keyframes steam {\n  0% {\n    opacity: 0.3;\n    transform: translateY(0) scaleX(1);\n  }\n  50% {\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 0;\n    transform: translateY(-10px) scaleX(1.5);\n  }\n}\n\n.notebook {\n  position: absolute;\n  top: 2px;\n  right: 35px;\n  width: 35px;\n  height: 25px;\n  background-color: #f2f2f2;\n  border-radius: 2px;\n  transform: rotate(5deg);\n  box-shadow: 2px 2px 5px rgba(0, 0, 0, 0.2);\n}\n\n.notebook:after {\n  content: '';\n  position: absolute;\n  top: 5px;\n  left: 5px;\n  width: 25px;\n  height: 2px;\n  background-color: #ccc;\n  box-shadow: 0 4px 0 #ccc, 0 8px 0 #ccc, 0 12px 0 #ccc;\n}\n\n.laptop {\n  position: absolute;\n  bottom: 89px;\n  left: 110px;\n  z-index: 12;\n}\n\n.laptop-screen {\n  width: 100px;\n  height: 70px;\n  background-color: #252525;\n  border-radius: 5px 5px 0 0;\n  transform: perspective(300px) rotateX(10deg);\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n  animation: screen-glow 4s ease-in-out infinite;\n  position: relative;\n}\n\n.laptop-screen:before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(135deg, #1A1E26 0%, #252A34 100%);\n  border-radius: 3px;\n  z-index: 1;\n}\n\n/* Code snippet styles */\n.code-snippet {\n  position: absolute;\n  top: 5px;\n  left: 5px;\n  right: 5px;\n  bottom: 5px;\n  z-index: 2;\n  display: flex;\n  font-family: 'Consolas', 'Monaco', monospace;\n  font-size: 4px;\n  line-height: 1.5;\n  overflow: hidden;\n}\n\n.code-line-numbers {\n  display: flex;\n  flex-direction: column;\n  background-color: rgba(0, 0, 0, 0.3);\n  padding: 1px 2px;\n  margin-right: 3px;\n  color: #777;\n  font-size: 4px;\n  text-align: right;\n}\n\n.code-line-numbers span {\n  display: block;\n  padding: 0 1px;\n  line-height: 1.5;\n  font-size: 4px;\n}\n\n.code-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.code-text {\n  white-space: nowrap;\n  margin-bottom: 0;\n  color: #E0E0E0;\n  font-size: 4px;\n  line-height: 1.5;\n}\n\n.code-text.indent {\n  padding-left: 10px;\n}\n\n.code-text.doubled {\n  padding-left: 20px;\n}\n\n.keyword {\n  color: #FF79C6;\n  font-weight: bold;\n}\n\n.function {\n  color: #50FA7B;\n}\n\n.namespace {\n  color: #BD93F9;\n}\n\n.symbol {\n  color: #F8F8F2;\n}\n\n.property {\n  color: #8BE9FD;\n  font-style: italic;\n}\n\n.cursor-blink {\n  position: absolute;\n  width: 4px;\n  height: 8px;\n  background-color: #F8F8F2;\n  opacity: 0.7;\n  bottom: 18px;\n  right: 35px;\n  animation: blink 1s step-end infinite;\n  z-index: 3;\n}\n\n@keyframes blink {\n  0%, 100% {\n    opacity: 0.7;\n  }\n  50% {\n    opacity: 0;\n  }\n}\n\n.laptop-keyboard {\n  width: 120px;\n  height: 10px;\n  background-color: #333;\n  border-radius: 0 0 5px 5px;\n  transform: perspective(300px) rotateX(70deg);\n  transform-origin: top;\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.5);\n}\n\n.laptop-keyboard:after {\n  content: '';\n  position: absolute;\n  top: 4px;\n  left: 50%;\n  width: 20px;\n  height: 2px;\n  background-color: #444;\n  transform: translateX(-50%);\n  border-radius: 2px;\n}\n\n.code-lines {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  right: 10px;\n  z-index: 13;\n}\n\n.code-line {\n  height: 3px;\n  background-color: #14F195;\n  margin-bottom: 8px;\n  opacity: 0.8;\n  width: 60%;\n  border-radius: 3px;\n}\n\n.code-line:nth-child(2) {\n  width: 45%;\n}\n\n.code-line:nth-child(3) {\n  width: 75%;\n}\n\n.solana-logo-small {\n  position: absolute;\n  bottom: 10px;\n  right: 10px;\n  width: 15px;\n  height: 15px;\n  background-color: #14F195;\n  border-radius: 50%;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 0.7;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(1.2);\n  }\n}\n\n.person {\n  position: absolute;\n  bottom: 90px;\n  left: 110px;\n  z-index: 15;\n  transform: rotate(0deg);\n}\n\n.head {\n  width: 30px;\n  height: 35px;\n  background-color: #ffd9b3;\n  border-radius: 50% 50% 45% 45%;\n  position: relative;\n  animation: head-move 4s ease-in-out infinite;\n  transform: rotate(-5deg);\n}\n\n@keyframes head-move {\n  0%, 100% {\n    transform: rotate(-5deg);\n  }\n  30% {\n    transform: rotate(-2deg);\n  }\n  70% {\n    transform: rotate(-7deg);\n  }\n}\n\n.hair {\n  position: absolute;\n  top: -10px;\n  left: -2px;\n  width: 34px;\n  height: 25px;\n  background-color: #4a3500;\n  border-radius: 50% 50% 0 0;\n}\n\n.face {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n\n.eyes {\n  position: absolute;\n  top: 15px;\n  left: 5px;\n  width: 20px;\n  height: 4px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.eyes:before, .eyes:after {\n  content: '';\n  width: 4px;\n  height: 4px;\n  background-color: #333;\n  border-radius: 50%;\n  animation: blink 4s infinite;\n}\n\n@keyframes blink {\n  0%, 96%, 100% {\n    transform: scaleY(1);\n  }\n  98% {\n    transform: scaleY(0.1);\n  }\n}\n\n.smile {\n  position: absolute;\n  bottom: 8px;\n  left: 10px;\n  width: 10px;\n  height: 5px;\n  border-bottom: 2px solid #333;\n  border-radius: 50%;\n}\n\n.body {\n  position: absolute;\n  top: 35px;\n  left: 3px;\n  width: 25px;\n  height: 50px;\n  background-color: #14B898;\n  border-radius: 8px 8px 0 0;\n  transform: rotate(0deg);\n  animation: subtle-sway 5s ease-in-out infinite;\n}\n\n@keyframes subtle-sway {\n  0%, 100% {\n    transform: rotate(0deg);\n  }\n  50% {\n    transform: rotate(-1deg);\n  }\n}\n\n.arms {\n  position: absolute;\n  top: 8px;\n  left: -5px;\n  width: 45px;\n  height: 30px;\n}\n\n.arm {\n  position: absolute;\n  width: 30px;\n  height: 5px;\n  background-color: #14B898;\n  border-radius: 5px;\n}\n\n.arm-left {\n  top: 15px;\n  left: -15px;\n  transform: rotate(25deg);\n}\n\n.arm-right {\n  top: 15px;\n  right: -15px;\n  transform: rotate(-30deg);\n  animation: typing 2s infinite;\n}\n\n@keyframes typing {\n  0%, 100% {\n    transform: rotate(-30deg) translateY(0);\n  }\n  50% {\n    transform: rotate(-35deg) translateY(-2px);\n  }\n}\n\n.legs {\n  position: absolute;\n  top: 80px;\n  left: -5px;\n  width: 35px;\n  height: 60px;\n}\n\n.leg {\n  position: absolute;\n  width: 8px;\n  height: 40px;\n  background-color: #14B898;\n  border-radius: 4px;\n}\n\n.leg-left {\n  left: 3px;\n  transform: rotate(0deg);\n  animation: weight-shift 4s ease-in-out infinite alternate;\n}\n\n.leg-right {\n  right: 3px;\n  transform: rotate(0deg);\n  animation: weight-shift 4s ease-in-out infinite alternate-reverse;\n}\n\n@keyframes weight-shift {\n  0%, 100% {\n    transform: translateY(0) rotate(0deg);\n  }\n  50% {\n    transform: translateY(-1px) rotate(0deg);\n  }\n}\n\n.leg:after {\n  content: '';\n  position: absolute;\n  bottom: -3px;\n  left: -2px;\n  width: 12px;\n  height: 5px;\n  background-color: #333;\n  border-radius: 3px 5px 3px 3px;\n  transform: rotate(0deg);\n}\n\n.potted-plant {\n  position: absolute;\n  bottom: 70px;\n  right: 40px;\n  z-index: 9;\n}\n\n.potted-plant:before {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 25px;\n  height: 20px;\n  background-color: #bd7b4c;\n  border-radius: 3px 3px 5px 5px;\n}\n\n.potted-plant:after {\n  content: '';\n  position: absolute;\n  bottom: 15px;\n  left: 5px;\n  width: 15px;\n  height: 35px;\n  background-color: #0fad7a;\n  border-radius: 50% 50% 0 0;\n  box-shadow: -10px -5px 0 -5px #0fad7a, 10px -10px 0 -5px #0fad7a;\n}\n\n.wall-art {\n  position: absolute;\n  top: 40px;\n  right: 60px;\n  width: 50px;\n  height: 35px;\n  background: linear-gradient(45deg, #14F195, #3a82ee);\n  border-radius: 3px;\n  border: 3px solid #5c6c8e;\n  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.2);\n  z-index: 5;\n}\n\n.wall-art:before {\n  content: '';\n  position: absolute;\n  top: -10px;\n  left: 50%;\n  width: 2px;\n  height: 10px;\n  background-color: #ddd;\n  transform: translateX(-50%);\n}\n\n.wall-art:after {\n  content: '';\n  position: absolute;\n  top: -12px;\n  left: 50%;\n  width: 10px;\n  height: 2px;\n  background-color: #ddd;\n  transform: translateX(-50%);\n}\n\n/* WeChat QR Code Popup Styles */\n.wechat-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(5px);\n}\n\n.wechat-popup {\n  background-color: white;\n  border-radius: 10px;\n  width: 90%;\n  max-width: 400px;\n  box-shadow: 0 5px 30px rgba(0, 0, 0, 0.3);\n  overflow: hidden;\n  animation: popup-appear 0.3s ease;\n}\n\n@keyframes popup-appear {\n  from {\n    opacity: 0;\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.wechat-popup-header {\n  background-color: #14F195;\n  color: #1E1E2E;\n  padding: 1rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.wechat-popup-header h3 {\n  margin: 0;\n  font-size: 1.2rem;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  color: #1E1E2E;\n  font-size: 1.5rem;\n  cursor: pointer;\n  line-height: 1;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  transition: background-color 0.2s ease;\n}\n\n.close-btn:hover {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n\n.wechat-popup-content {\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n}\n\n.wechat-popup-image {\n  max-width: 200px;\n  margin-bottom: 1rem;\n  border: 2px solid #14F195;\n  border-radius: 5px;\n}\n\n.wechat-popup-content p {\n  color: #555;\n  margin: 0;\n}\n\n@media (max-width: 768px) {\n  .hero {\n    flex-direction: column;\n    padding: 1rem;\n  }\n  \n  .hero-content {\n    padding: 0;\n    margin-bottom: 2rem;\n    text-align: center;\n  }\n  \n  .hero-buttons {\n    justify-content: center;\n  }\n  \n  .dream-lifestyle-illustration {\n    width: 320px;\n    height: 320px;\n  }\n  \n  .window-frame {\n    height: 65%;\n  }\n\n  .window-reflection {\n    bottom: 70px;\n    height: 40px;\n  }\n\n  .city-glow {\n    top: 80px;\n    left: 30px;\n    width: 260px;\n  }\n\n  .illustration-label {\n    font-size: 0.8rem;\n  }\n\n  .wechat-popup {\n    width: 95%;\n  }\n\n  .wechat-popup-image {\n    max-width: 150px;\n  }\n  \n  /* Adjust building positions for mobile */\n  .building-1 {\n    left: 10px;\n    width: 30px;\n  }\n  \n  .building-2 {\n    left: 45px;\n    width: 25px;\n  }\n  \n  .building-3 {\n    left: 80px;\n    width: 40px;\n  }\n  \n  .building-4 {\n    left: 125px;\n    width: 35px;\n  }\n  \n  .building-5 {\n    left: 165px;\n    width: 30px;\n  }\n  \n  .building-6 {\n    left: 200px;\n    width: 25px;\n  }\n}\n\n@keyframes screen-glow {\n  0%, 100% {\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);\n  }\n  50% {\n    box-shadow: 0 0 15px rgba(20, 241, 149, 0.3);\n  }\n}\n\n/* Window reflection on floor */\n.window-reflection {\n  position: absolute;\n  bottom: 70px;\n  left: 0;\n  width: 100%;\n  height: 60px;\n  background: linear-gradient(to bottom, rgba(255, 123, 84, 0.2) 0%, rgba(75, 82, 103, 0.05) 100%);\n  filter: blur(5px);\n  transform: perspective(300px) rotateX(70deg) scale(1, 0.4);\n  opacity: 0.3;\n  z-index: 2;\n  border-radius: 0;\n}\n\n/* City light glow effect */\n.city-glow {\n  position: absolute;\n  top: 100px;\n  left: 50px;\n  width: 280px;\n  height: 20px;\n  background: radial-gradient(ellipse at center, rgba(255, 179, 71, 0.2) 0%, rgba(255, 179, 71, 0) 70%);\n  filter: blur(10px);\n  opacity: 0.6;\n  z-index: 2;\n}\n\n/* Hide elements that conflict with the expanded window */\n.wall-art {\n  display: none;\n}\n\n.potted-plant {\n  display: none;\n}\n\n/* Car lights on city streets */\n.car-lights {\n  position: absolute;\n  bottom: 5%;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  z-index: 4;\n}\n\n.car {\n  position: absolute;\n  height: 2px;\n  border-radius: 2px;\n}\n\n.car-1 {\n  width: 8px;\n  background-color: rgba(255, 255, 255, 0.8);\n  bottom: 0;\n  left: -10px;\n  animation: car-move-right 8s linear infinite;\n}\n\n.car-2 {\n  width: 6px;\n  background-color: rgba(255, 100, 100, 0.8);\n  bottom: 8px;\n  right: -8px;\n  animation: car-move-left 12s linear infinite 3s;\n}\n\n.car-3 {\n  width: 7px;\n  background-color: rgba(255, 255, 255, 0.8);\n  bottom: 16px;\n  left: -12px;\n  animation: car-move-right 10s linear infinite 2s;\n}\n\n@keyframes car-move-right {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(380px);\n  }\n}\n\n@keyframes car-move-left {\n  0% {\n    transform: translateX(0);\n  }\n  100% {\n    transform: translateX(-380px);\n  }\n}\n\n/* Add more car lights for the wider window */\n.car-4 {\n  width: 9px;\n  background-color: rgba(255, 255, 255, 0.8);\n  bottom: 24px;\n  left: -15px;\n  animation: car-move-right 15s linear infinite 5s;\n}\n\n.car-5 {\n  width: 7px;\n  background-color: rgba(255, 100, 100, 0.8);\n  bottom: 32px;\n  right: -10px;\n  animation: car-move-left 18s linear infinite 7s;\n}\n\n/* Airplane styles with improved visibility and contrail */\n.airplane {\n  position: absolute;\n  z-index: 6;\n}\n\n.airplane-body {\n  position: absolute;\n  width: 40px;\n  height: 8px;\n  background-color: rgba(255, 255, 255, 0.9);\n  border-radius: 50% 50% 0 0;\n}\n\n.airplane-tail {\n  position: absolute;\n  top: -8px;\n  right: 0;\n  width: 10px;\n  height: 10px;\n  background-color: rgba(255, 255, 255, 0.9);\n  clip-path: polygon(0% 100%, 100% 100%, 100% 0%);\n}\n\n.airplane-wing {\n  position: absolute;\n  top: 4px;\n  left: 10px;\n  width: 30px;\n  height: 6px;\n  background-color: rgba(255, 255, 255, 0.9);\n  border-radius: 50% 50% 0 0;\n  transform: rotate(10deg);\n}\n\n.airplane-contrail {\n  position: absolute;\n  top: 4px;\n  right: -50px;\n  width: 50px;\n  height: 2px;\n  background: linear-gradient(to left, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.6));\n}\n\n.airplane-1 {\n  top: 40px;\n  left: -50px;\n  animation: fly-right 30s linear infinite;\n}\n\n.airplane-2 {\n  top: 80px;\n  right: -50px;\n  transform: scale(0.3) rotateY(180deg);\n  animation: fly-left 45s linear infinite 15s;\n}\n\n/* Birds styles with improved visibility */\n.birds {\n  position: absolute;\n  z-index: 6;\n}\n\n.bird {\n  position: absolute;\n  width: 10px;\n  height: 8px;\n  clip-path: polygon(0% 50%, 50% 0%, 100% 50%);\n  background-color: rgba(0, 0, 0, 0.65);\n  animation: bird-flap 0.8s ease-in-out infinite;\n}\n\n.bird-group-1 {\n  top: 30px;\n  left: -30px;\n  transform: scale(0.8);\n  animation: bird-fly-right 20s linear infinite 2s;\n}\n\n.bird-group-2 {\n  top: 60px;\n  right: -30px;\n  transform: scale(0.6) rotate(180deg);\n  animation: bird-fly-left 25s linear infinite 7s;\n}\n\n.bird-group-3 {\n  top: 20px;\n  left: 50%;\n  transform: scale(0.5) translateX(-50%);\n  animation: bird-fly-up 35s linear infinite 5s;\n}\n\n.bird-1 {\n  top: 0;\n  left: 0;\n}\n\n.bird-2 {\n  top: -5px;\n  left: 15px;\n}\n\n.bird-3 {\n  top: 0;\n  left: 30px;\n}\n\n.bird-4 {\n  top: 5px;\n  left: 10px;\n}\n\n.bird-5 {\n  top: 5px;\n  left: 25px;\n}\n\n@keyframes bird-flap {\n  0%, 100% {\n    clip-path: polygon(0% 50%, 50% 0%, 100% 50%);\n  }\n  50% {\n    clip-path: polygon(0% 45%, 50% 10%, 100% 45%);\n  }\n}\n\n@keyframes bird-fly-right {\n  0% {\n    transform: scale(0.8) translateX(0) translateY(0);\n  }\n  50% {\n    transform: scale(0.8) translateX(160px) translateY(-20px);\n  }\n  100% {\n    transform: scale(0.8) translateX(320px) translateY(0);\n  }\n}\n\n@keyframes bird-fly-left {\n  0% {\n    transform: scale(0.6) rotate(180deg) translateX(0) translateY(0);\n  }\n  50% {\n    transform: scale(0.6) rotate(180deg) translateX(140px) translateY(15px);\n  }\n  100% {\n    transform: scale(0.6) rotate(180deg) translateX(280px) translateY(0);\n  }\n}\n\n@keyframes bird-fly-up {\n  0% {\n    transform: scale(0.5) translateX(-50%) translateY(0);\n    opacity: 0;\n  }\n  10% {\n    opacity: 1;\n  }\n  90% {\n    opacity: 1;\n  }\n  100% {\n    transform: scale(0.5) translateX(-50%) translateY(-120px);\n    opacity: 0;\n  }\n}\n\n/* Animation keyframes for airplane */\n@keyframes fly-right {\n  0% {\n    transform: scale(0.5) translateX(0) translateY(0);\n  }\n  50% {\n    transform: scale(0.5) translateX(200px) translateY(-10px);\n  }\n  100% {\n    transform: scale(0.5) translateX(400px) translateY(0);\n  }\n}\n\n@keyframes fly-left {\n  0% {\n    transform: scale(0.3) rotateY(180deg) translateX(0) translateY(0);\n  }\n  50% {\n    transform: scale(0.3) rotateY(180deg) translateX(150px) translateY(10px);\n  }\n  100% {\n    transform: scale(0.3) rotateY(180deg) translateX(300px) translateY(0);\n  }\n}\n\n/* Section transition element */\n.hero-transition-bottom {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 50px;\n  background: linear-gradient(to bottom, transparent, #131b2c);\n  z-index: 2;\n}\n\n.hero-dots {\n  position: absolute;\n  bottom: 15px;\n  left: 50%;\n  transform: translateX(-50%);\n  font-size: 24px;\n  letter-spacing: 8px;\n  color: rgba(153, 69, 255, 0.4);\n  z-index: 3;\n} \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
